import type { FC } from 'react'

import { Input } from '@skytech/ui'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import { Translation } from '@/app/translations/Translation'

export const SduVismaLonnV3: FC = () => (
  <div className="mt-3">
    <Field name="salaryDeductionCodeDevice">
      {({ field, meta }: FieldProps) => (
        <Input
          isFullWidth
          capitalizeLabel
          id="salaryDeductionCodeDevice"
          label={
            <>
              <Translation id="Accounting code mobile usage" />*
            </>
          }
          marginBottom={16}
          touched={meta.touched}
          error={meta.error}
          {...field}
        />
      )}
    </Field>
  </div>
)
